export const CARAMEL_FINANCING = {
  text: 'No-pressure financing',
  icon: '/icons/percent-in-hand.svg',
  width: 30,
  height: 30,
};
export const CARAMEL_DELIVERY = {
  text: 'Pickup or delivery',
  icon: '/icons/delivery-truck.svg',
  width: 38,
  height: 30,
};
export const CARAMEL_CHECKOUT = {
  text: 'Simple Online Checkout',
  icon: '/icons/finger-selecting.svg',
  width: 38,
  height: 30,
};
export const CARAMEL_IDENTITY_VERIFIED = {
  text: 'Seller identity verification',
  icon: '/icons/identity-verified.svg',
  width: 26,
  height: 32,
};
export const CARAMEL_SECURE_PAYMENT = {
  text: 'Secure payment & financing',
  icon: '/icons/percent-in-hand.svg',
  width: 30,
  height: 30,
};

export const CARAMEL_MAKE_AN_OFFER_CTA = 'Make an Offer';
export const CARAMEL_DOMAIN = 'drivecaramel.com';

export const CARAMEL_ENTRY_POINT_DATA = {
  benefits: [CARAMEL_CHECKOUT, CARAMEL_FINANCING, CARAMEL_DELIVERY],
  cta: 'Start Purchase',
  header: 'Online Checkout and Delivery',
};

export const CARAMEL_ENTRY_POINT_PRIVATE_DATA = {
  benefits: [CARAMEL_IDENTITY_VERIFIED, CARAMEL_SECURE_PAYMENT, CARAMEL_DELIVERY],
  cta: 'Start Purchase',
  header: 'Get Simple, Secure Checkout',
};

export const DEAL_IN_PROGRESS = 'in_progress';
export const DEAL_NOT_STARTED = 'not_started';
export const DEAL_COMPLETED = 'completed';

export const DEAL_STATUS_PENDING = 'Pending Sale';
export const DEAL_STATUS_SOLD = 'Recently Sold';
